import React, { useState, useEffect } from "react";
import { Form, Input } from "antd";
import PropTypes from 'prop-types';

const moment = require("moment");

const layout = {
  labelCol: {
    span: 10,
  },
  wrapperCol: {
    span: 20,
  },
  labelAlign: "left",
};

// var d  = new Date(0);

const style = { margin: "2px", height: "30px", labelAlign: "left" };

const inputStyle = { padding: "2px" };

export const VehiclePane = ({ vehicalDetails }) => {
  const [styleLkaRight, setStyleLkaRight] = useState({ padding: "2px" });
  const [styleLkaLeft, setStyleLkaLeft] = useState({ padding: "2px" });
  try {
    var {
      timestamp,
      speed,
      yawrate,
      long_accelaration,
      lateral_accelaration,
      steering_wheel_angle,
      lka_right_status,
      lka_left_status,
      updated_timestamp
    } = vehicalDetails;
  } catch (err) {
    //empty function
  }
  console.log(lka_right_status, lka_left_status);
  useEffect(() => {
    if (lka_right_status === "LKA Available for Right Side") {
      setStyleLkaRight({
        padding: "2px",
        backgroundColor: "#008000",
        color: "#FFFFFF",
      });
    } else if (lka_right_status === "LKA Suppressed for Right Side") {
      setStyleLkaRight({
        padding: "2px",
        backgroundColor: "#FFBF00",
        color: "#FFFFFF",
      });
    } else if (lka_right_status === "LKA Active for Right Side") {
      setStyleLkaRight({
        padding: "2px",
        backgroundColor: "#FF0000",
        color: "#FFFFFF",
      });
    }else {
      setStyleLkaRight({
        padding: "2px",
        backgroundColor: "#FFFFFF",
        color: "#000000",
      });
    }

    if (lka_left_status === "LKA Available for Left Side") {
      setStyleLkaLeft({
        padding: "2px",
        backgroundColor: "#008000",
        color: "#FFFFFF",
      });
    } else if (lka_left_status === "LKA Suppressed for Left Side") {
      setStyleLkaLeft({
        padding: "2px",
        backgroundColor: "#FFBF00",
        color: "#FFFFFF",
      });
    } else if (lka_left_status === "LKA Active for Left Side") {
      setStyleLkaLeft({
        padding: "2px",
        backgroundColor: "#FF0000",
        color: "#FFFFFF",
      });
    }else {
      setStyleLkaLeft({
        padding: "2px",
        backgroundColor: "#FFFFFF",
        color: "#000000",
      });
    }
  }, [vehicalDetails,lka_left_status,lka_right_status]);
  return (
    <Form
      {...layout}
      fields={[
        {
          name: ["timestamp"],
          value:
            timestamp === undefined ? null : moment.unix(timestamp).utc()._d,
        },
        {
          name: ["speed"],
          value: speed === undefined ? null : Math.round(speed * 1000) / 1000,
        },
        {
          name: ["yawrate"],
          value:
            yawrate === undefined ? null : Math.round(yawrate * 1000) / 1000,
        },
        {
          name: ["long_accelaration"],
          value:
            long_accelaration === undefined
              ? null
              : Math.round(long_accelaration * 1000) / 1000,
        },
        {
          name: ["lateral_accelaration"],
          value:
            lateral_accelaration === undefined
              ? null
              : Math.round(lateral_accelaration * 1000) / 1000,
        },
        {
          name: ["steering_wheel_angle"],
          value:
            steering_wheel_angle === undefined ? null : steering_wheel_angle,
        },
        {
          name: ["lka_right_status"],
          value: lka_right_status === undefined ? null : lka_right_status,
        },
        {
          name: ["lka_left_status"],
          value: lka_left_status === undefined ? null : lka_left_status,
        },
        {
          name: ["updated_timestamp"],
          value: updated_timestamp === undefined ? null : updated_timestamp,
        },
      ]}
    >
      <Form.Item 
        name="timestamp" 
        style={style}
      >
        <Input style={{ padding: "3px", width: "120%" }} />
      </Form.Item>
      <Form.Item 
        label="Yawrate [deg/s]" 
        name="yawrate" 
        style={style}
      >
        <Input style={inputStyle} />
      </Form.Item>
      <Form.Item
        label="Long Accel [m/s^2]"
        name="long_accelaration"
        style={style}
      >
        <Input style={inputStyle} />
      </Form.Item>
      <Form.Item
        label="Lateral Accel [m/s^2]"
        name="lateral_accelaration"
        style={style}
      >
        <Input style={inputStyle} />
      </Form.Item>
      <Form.Item
        label="Steering Angle [deg/s]"
        name="steering_wheel_angle"
        style={style}
      >
        <Input style={inputStyle} />
      </Form.Item>
      <Form.Item 
        label="LKA Right Status" 
        name="lka_right_status" 
        style={style}
      >
        <Input style={styleLkaRight} />
      </Form.Item>
      <Form.Item 
        label="LKA Left Status" 
        name="lka_left_status" 
        style={style}
      >
        <Input style={styleLkaLeft} />
      </Form.Item>
      <Form.Item 
        name="updated_timestamp" 
        style={style}
      >
        <Input style={{ padding: "3px", width: "120%" }} />
      </Form.Item>
    </Form>
  );
};

VehiclePane.propTypes = {
  vehicalDetails: PropTypes.shape({
    timestamp: PropTypes.number,
    speed: PropTypes.number,
    yawrate: PropTypes.number,
    long_accelaration: PropTypes.number,
    lateral_accelaration: PropTypes.number,
    steering_wheel_angle: PropTypes.number,
    lka_right_status: PropTypes.string,
    lka_left_status: PropTypes.string,
    updated_timestamp: PropTypes.number
  })
}